import {CloseOutlined, SearchOutlined} from '@ant-design/icons';
import {Input} from '@ds/components';

type CampaignSearchHeaderProps = {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClose: () => void;
};

const CampaignSearchHeader: React.FC<CampaignSearchHeaderProps> = ({value, onChange, onClose}) => {
  return (
    <div className="flex items-center py-2 ps-4">
      <button
        type="button"
        className="flex size-12 shrink-0 items-center justify-center text-subtitle-lg"
        onClick={onClose}
        aria-label="بستن جستجو"
      >
        <CloseOutlined aria-hidden />
      </button>
      <Input
        value={value}
        prefix={<SearchOutlined aria-hidden />}
        placeHolder="جستجو..."
        onChange={onChange}
      />
    </div>
  );
};

export default CampaignSearchHeader;
